export default __webpack_public_path__ + "static/media/language-sl.8c957309.svg";